/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectDomain } from './ProjectDomain';
import {
    ProjectDomainFromJSON,
    ProjectDomainFromJSONTyped,
    ProjectDomainToJSON,
    ProjectDomainToJSONTyped,
} from './ProjectDomain';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface DomainData
 */
export interface DomainData {
    /**
     * 
     * @type {ProjectDomain}
     * @memberof DomainData
     */
    projectDomain?: ProjectDomain;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof DomainData
     */
    turnoverNetGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof DomainData
     */
    turnoverGrossGranular?: { [key: string]: MoneyOutput; };
}

/**
 * Check if a given object implements the DomainData interface.
 */
export function instanceOfDomainData(value: object): value is DomainData {
    return true;
}

export function DomainDataFromJSON(json: any): DomainData {
    return DomainDataFromJSONTyped(json, false);
}

export function DomainDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainData {
    if (json == null) {
        return json;
    }
    return {
        
        'projectDomain': json['projectDomain'] == null ? undefined : ProjectDomainFromJSON(json['projectDomain']),
        'turnoverNetGranular': json['turnoverNetGranular'] == null ? undefined : (mapValues(json['turnoverNetGranular'], MoneyOutputFromJSON)),
        'turnoverGrossGranular': json['turnoverGrossGranular'] == null ? undefined : (mapValues(json['turnoverGrossGranular'], MoneyOutputFromJSON)),
    };
}

export function DomainDataToJSON(json: any): DomainData {
    return DomainDataToJSONTyped(json, false);
}

export function DomainDataToJSONTyped(value?: DomainData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectDomain': ProjectDomainToJSON(value['projectDomain']),
        'turnoverNetGranular': value['turnoverNetGranular'] == null ? undefined : (mapValues(value['turnoverNetGranular'], MoneyOutputToJSON)),
        'turnoverGrossGranular': value['turnoverGrossGranular'] == null ? undefined : (mapValues(value['turnoverGrossGranular'], MoneyOutputToJSON)),
    };
}

